/**
 * 「还差 N 项才能发布」的文案（2026-10-16）：N 只数**阻断项**，提示（severity=warn）不挡发布，单独显示条数。
 * 不这么分的话，所有 A0 价目表里的旧 3×3 会让每一版都显示「还差 1 项才能发布」，而其实能发布——字面和事实矛盾。
 */
export interface PendingCount { blocking: number; warns: number }

export function pendingChipText(t: (key: "ver.pendingN" | "ver.pendingOk" | "ver.pendingWarns", vars?: Record<string, string | number>) => string, p: PendingCount): string {
  const warn = p.warns ? t("ver.pendingWarns", { n: p.warns }) : "";
  if (p.blocking) return warn ? `${t("ver.pendingN", { n: p.blocking })} · ${warn}` : t("ver.pendingN", { n: p.blocking });
  return warn ? `${t("ver.pendingOk")} · ${warn}` : t("ver.pendingOk");
}

/** 配置检查的问题行 → 计数：缺省 severity 当阻断（与服务端 blockingIssues 同口径） */
export const countPending = (rows: Array<{ severity?: string }>): PendingCount => ({
  blocking: rows.filter((r) => r.severity !== "warn").length,
  warns: rows.filter((r) => r.severity === "warn").length,
});
